import { createAsyncThunk } from '@reduxjs/toolkit';
import { instance, setToken } from '../../shared/services/app/instance';
import * as toasty from '../../shared/toastify/toastify';

const getAllSettings = createAsyncThunk(
  'notifications/fetchAll',
  async (_, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;
    setToken(token);

    try {
      const { data } = await instance.get('/notification-settings');
      return data.settings;
    } catch (error) {
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const createSetting = createAsyncThunk(
  'notifications/create',
  async (updates, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;
    setToken(token);

    try {
      const { data } = await instance.post('/notification-settings', updates);
      toasty.toastSuccess('Налаштування створено');
      return data.settings;
    } catch (error) {
      toasty.toastError('Помилка створення');
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const updateSetting = createAsyncThunk(
  'notifications/update',
  async ({ code, updates }, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;
    setToken(token);

    try {
      const { data } = await instance.patch(
        `/notification-settings/${code}`,
        updates
      );
      toasty.toastSuccess('Налаштування оновлено');
      return data.settings;
    } catch (error) {
      toasty.toastError('Помилка оновлення');
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const bulkUpdateSettings = createAsyncThunk(
  'notifications/bulkUpdate',
  async (updates, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;
    setToken(token);

    try {
      const { data } = await instance.patch(
        '/notification-settings/bulk',
        { updates }
      );
      toasty.toastSuccess('Всі налаштування оновлено');
      return data.settings;
    } catch (error) {
      toasty.toastError('Помилка масового оновлення');
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const sendNotification = createAsyncThunk(
  'notifications/send',
  async (payload, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;
    setToken(token);

    try {
      await instance.post('/notification-settings/send', payload);
      toasty.toastSuccess('Сповіщення надіслано');
    } catch (error) {
      toasty.toastError('Помилка відправки');
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const broadcastNotification = createAsyncThunk(
  'notifications/broadcast',
  async (payload, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;
    setToken(token);

    try {
      const { data } = await instance.post('/notification-settings/broadcast', payload);
      const msg = data.sent === -1
        ? `Масову відправку запущено: збережено ${data.saved} з ${data.total}, push надсилається у фоновому режимі`
        : `Масову відправку завершено: надіслано ${data.sent}, помилок ${data.failed} (всього ${data.total})`;
      toasty.toastSuccess(msg);
      return data;
    } catch (error) {
      toasty.toastError('Помилка масової відправки');
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const notificationOperations = {
  getAllSettings,
  createSetting,
  updateSetting,
  bulkUpdateSettings,
  sendNotification,
  broadcastNotification,
};

export default notificationOperations;
